export const webshop = {
  hero: {
    title: {
      pt1: 'A',
      pt2: 'webshop',
      pt3: 'designed specifically for restaurants'
    },
    description: 'Unlock streamlined operations and increased sales with Bistroo\'s Webshop. Our clients report significant time savings and improved efficiency — while driving real revenue growth.'
  },
  paragraphs: {
    paragraph_1: {
      title: 'Increase your sales, while reducing costs',
      text: 'A well-optimised webshop generates up to 25% more orders, with increased average order values, compared to traditional ordering methods. Save 20% in operational costs and time, compared to handling orders by phone, while easily handling more orders.',
      cta: 'Explore the Bistroo packages'
    },
    paragraph_2: {
      title: 'Earn more, pay less, and modify at will',
      text: 'From free packages, to monthly subscriptions. Choose the pricing plan that fits your appetite and see for yourself what Bistroo’s products can do for you. With monthly subscriptions and entry-level pricing options, it is easy and accessible to experience the benefits first-hand without signing a long-term contract.',
      cta: ''
    },
    paragraph_3: {
      title: 'Order with Google',
      text: 'We put you on the map - literally. We will optimise your webshop for Google Search and Google Maps. Included in all Bistroo Packages.',
      cta: 'Explore the Bistroo packages'
    },
    paragraph_4: {
      title: 'Customise to your brand',
      text: 'A full white-label package is available, to completely brand the user\'s journey in your restaurant\'s style. From the landing-page, to the ordering and confirmation-flow. All in your specific style and tone-of-voice.',
      cta: ''
    }
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Handle orders, with no extra effort.',
        text: 'Handle any order to perfection. Access your order view from any device, at any time. Print order-tickets that fit your requirements on any print device.',
        button: '',
        img_alt: ''
      },
      card_2: {
        title: 'Integrations.',
        text: 'Connect your preffered POS-system, or third-pary tooling.',
        button: '',
        img_alt: ''
      },
      card_3: {
        title: 'Upselling options.',
        text: 'Configure extensive up-selling to further grow average order value of your orders.',
        button: '',
        img_alt: ''
      },
      card_4: {
        title: 'Grow Revenue.',
        text: 'Up to 30% more revenue with an optimised webshop.',
        button: '',
        img_alt: ''
      },
      card_5: {
        title: 'Discounts and Loyalty.',
        text: 'Set-up promotions, discounts and loyalty rewards for your returning customers.',
        button: '',
        img_alt: ''
      }
    }
  },
  testimonial: {
    text: '"Since working with Bistroo, our to-go orders have increased, and any issues are quickly resolved by their responsive team."',
    cta: 'Read Marieke\'s story',
    name: 'Marieke van Loon',
    job_title: 'Business Owner'
  }
}